import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useSearchActions, useSearchState } from '#src/app/pages/searchV2/shared/searchState';

type Result = ModelHookResult<
	{
		selectedLocation: string;
	},
	{
		clearSelectedLocation: () => void;
	}
>;

export function useClearSelectedLocation(): Result {
	const state = useSearchState();
	const actions = useSearchActions();
	const track = useTracking();

	const selectedLocation = state.locationCities[0] || state.locationCountries[0] || '';

	return {
		data: {
			selectedLocation,
		},
		actions: {
			clearSelectedLocation: useCallback(() => {
				if (selectedLocation) {
					void track('search', { q: state.query || '', context: 'clear_location_filter' });
					actions.clearLocation();
				}
			}, [selectedLocation, track, state.query, actions]),
		},
	};
}
